import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '../views/404'
import checkoutGuard from './guards/checkout'

Vue.use(Router)

export default ({ store }) => {
  const routerConfig = {
    mode: 'history',
    routes: [
      {
        path: '/',
        name: 'root',
        redirect: { name: 'checkout' }
      }, {
        alias: '/:shoppingCartID',
        path: '/checkout/:shoppingCartID',
        name: 'checkout',
        props: true,
        component: () => import('../views/Checkout'),
        beforeEnter: checkoutGuard({ store })
      },

      { path: '*', component: NotFound }
    ]
  }

  const router = new Router(routerConfig)
  return router
}
